export const excludedFields = ["id", "created_at", "updated_at"];
export const dateFields = ["installation_date"];
